import { PROCESS_STEPS } from "../data/services";
import { Reveal, SectionHeading } from "../components/site/Reveal";

export const Process = () => (
  <section className="relative py-28 md:py-36" data-testid="process-section">
    <div className="mx-auto max-w-7xl px-6">
      <SectionHeading
        eyebrow="Proceso Netsys"
        title={<>De un problema a una <span className="text-gradient">solución inteligente.</span></>}
        testId="process-heading"
      />
      <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-[var(--line)] bg-[var(--line)] sm:grid-cols-2 lg:grid-cols-3">
        {PROCESS_STEPS.map((step, i) => (
          <Reveal key={step.num} delay={i * 0.09} className="h-full">
            <div className="group h-full bg-[var(--bg)] p-8 transition-colors duration-500 hover:bg-[var(--surface)]" data-testid={`process-step-${step.num}`}>
              <span className="mono text-sm text-[var(--green)]">{step.num}</span>
              <h3 className="mt-5 text-xl font-bold tracking-tight">{step.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-[var(--muted)]">{step.text}</p>
              <div className="mt-6 h-px w-10 bg-gradient-to-r from-[var(--green)] to-[var(--cyan)] transition-all duration-500 group-hover:w-full" aria-hidden="true" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
